import React, { useEffect, useState } from 'react'

import style from './CategoryItem.module.css'
import { TaskItem } from './TaskItem/TaskItem'

import { ReactComponent as ArrowIcon } from 'assets/icons/arrow-down-icon.svg'
import { useAppSelector } from 'common/hooks'
import { Category } from 'data/categories'
import { selectSearchText } from 'features/dashboard'
import { selectCurrentTask } from 'features/simulator'

type PropsType = {
  category: Category
}

export const CategoryItem = ({ category }: PropsType) => {
  const currentTask = useAppSelector(selectCurrentTask)
  const [isOpen, setIsOpen] = useState(false)
  const isSearching = useAppSelector(selectSearchText) !== ''

  let isCurrentCategory = false

  if (currentTask) {
    isCurrentCategory = currentTask.categoryId === category.id
  }

  useEffect(() => {
    setIsOpen(isSearching)
  }, [isSearching])

  return (
    <li
      className={`${style.item} ${isOpen ? style['item--open'] : ''} ${
        isCurrentCategory ? style['current-category'] : ''
      }`}
    >
      <button className={style.button} onClick={() => setIsOpen(!isOpen)}>
        <ArrowIcon className={style.icon} />
        {category.title}
      </button>
      <ul className={style['subcategory-list']}>
        {category.tasks.map(task => (
          <TaskItem key={task.id} task={task} />
        ))}
      </ul>
    </li>
  )
}
